(function () {
  function init() {
    var addToCartButton = document.querySelector('.add-to-cart-button');
    if (!addToCartButton) return; // not a product page, do nothing

    var anchor = addToCartButton.closest('.buy-buttons-block') || addToCartButton;

    var bar = document.createElement('div');
    bar.className = 'dolesti-sticky-cart';
    bar.innerHTML =
      '<span class="dolesti-sticky-cart__title"></span>' +
      '<span class="dolesti-sticky-cart__price"></span>' +
      '<button type="button" class="dolesti-sticky-cart__button">Buy Now</button>';
    document.body.appendChild(bar);

    var titleEl = document.querySelector('h1');
    if (titleEl) {
      bar.querySelector('.dolesti-sticky-cart__title').textContent = titleEl.textContent.trim();
    }

    var priceEl = document.querySelector('.price__container .price-item, .price .price-item, [data-testid="price"]');
    if (priceEl) {
      bar.querySelector('.dolesti-sticky-cart__price').textContent = priceEl.textContent.trim();
    }

    bar.querySelector('.dolesti-sticky-cart__button').addEventListener('click', function () {
      // Prefer the real "Buy it now" dynamic checkout button so this actually
      // goes straight to checkout, not just adds to cart.
      var buyNowButton = document.querySelector('.shopify-payment-button__button');
      if (buyNowButton) {
        buyNowButton.click();
        return;
      }
      // Fallback: if the dynamic checkout button isn't available yet (still
      // loading, or unavailable for this product), fall back to add-to-cart
      // so the click still does something useful rather than nothing.
      var liveAddToCart = document.querySelector('.add-to-cart-button');
      if (liveAddToCart) liveAddToCart.click();
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.classList.remove('dolesti-sticky-cart--visible');
            } else if (entry.boundingClientRect.top < 0) {
              bar.classList.add('dolesti-sticky-cart--visible');
            } else {
              bar.classList.remove('dolesti-sticky-cart--visible');
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(anchor);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
